module.exports = __webpack_public_path__ + "static/img/位图@2x.5711e87b.png";